module.exports = __webpack_public_path__ + "img/f03be4ea350fd3338bdb54887f603790.png";